import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { PortalConfigProvider } from "./context/PortalConfigContext";

// MSAL configuration for Microsoft authentication
const msalConfig = {
  auth: {
    clientId:
      process.env.REACT_APP_MICROSOFT_CLIENT_ID || "your-client-id-here", // Replace with Ergo's Azure AD client ID
    authority: "https://login.microsoftonline.com/common", // Use "common" for multi-tenant or specific tenant ID
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MsalProvider instance={msalInstance}>
    <GoogleOAuthProvider
      clientId={
        process.env.REACT_APP_GOOGLE_CLIENT_ID || process.env.GOOGLE_CLIENT_ID
      }
    >
      <BrowserRouter>
        <PortalConfigProvider>
          <App />
        </PortalConfigProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </MsalProvider>
);
